import script from "./MaintenanceAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./MaintenanceAdmin.vue?vue&type=script&setup=true&lang=js"

import "./MaintenanceAdmin.vue?vue&type=style&index=0&id=763528dc&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-763528dc"]])

export default __exports__